<div class="activation-wrapper modal-wrapper">
  <div class="activation-card" [class.success]="isSuccess" [class.error]="isSuccess === false">
    <div class="card-accent"></div>

    <div class="card-header">
      <div class="brand-wrap">
        <img src="assets/white_lotus_icon.png" alt="GSP" class="brand" />
        <div class="titles">
          <h2>Registration Completed</h2>
          <p class="subtitle">GSP Portal</p>
        </div>
      </div>
      <div class="status-pill" *ngIf="!loading">
        <span [class.ok]="isSuccess" [class.fail]="isSuccess === false">
          {{ isSuccess ? 'Confirmed' : 'Failed' }}
        </span>
      </div>
    </div>

    <div class="card-body" *ngIf="loading">
      <div class="spinner"></div>
      <div class="loading-text">Preparing your account...</div>
    </div>

    <div class="card-body" *ngIf="!loading">
      <div class="status-hero" [class.ok]="isSuccess" [class.fail]="isSuccess === false">
        <div class="icon ok" *ngIf="isSuccess" aria-label="Success">
          <svg viewBox="0 0 24 24" width="28" height="28" focusable="false" aria-hidden="true">
            <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.2 13.2-3.5-3.5 1.4-1.4 2.1 2.1 4.9-4.9 1.4 1.4-6.3 6.3z"/>
          </svg>
        </div>
        <div class="icon fail" *ngIf="isSuccess === false" aria-label="Failed">
          <svg viewBox="0 0 24 24" width="28" height="28" focusable="false" aria-hidden="true">
            <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm3.5 12.1-1.4 1.4L12 13.4l-2.1 2.1-1.4-1.4L10.6 12 8.5 9.9l1.4-1.4L12 10.6l2.1-2.1 1.4 1.4L13.4 12l2.1 2.1z"/>
          </svg>
        </div>
      </div>

      <div class="message" [innerHTML]="serverMessageHtml"></div>

      <div class="actions">
        <button class="btn primary" (click)="goToLogin()">Go to Login</button>
        <a class="link" (click)="dialogRef.close()">Close</a>
      </div>
    </div>
  </div>
</div>

